import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Zap } from "lucide-react";

const ORDERS = [
  { hood: "Kensington", detail: "24 items picked in 7 min" },
  { hood: "Beltline", detail: "delivered in 16 min" },
  { hood: "Bridgeland", detail: "32 items picked in 6 min" },
  { hood: "Mission", detail: "delivered in 19 min" },
  { hood: "Downtown Core", detail: "driver 3 blocks away" },
  { hood: "Brentwood", detail: "delivered in 21 min" },
  { hood: "Beltline", detail: "18 items picked in 5 min" },
  { hood: "Kensington", detail: "driver just picked up" },
  { hood: "Mission", detail: "41 items picked in 9 min" },
  { hood: "Downtown Core", detail: "delivered in 14 min" },
];

const ITEM_MOTION = {
  initial: { y: 20, opacity: 0 },
  animate: { y: 0, opacity: 1 },
  exit: { y: -20, opacity: 0 },
  transition: { duration: 0.45, ease: [0.16, 1, 0.3, 1] },
};

export const OrderTicker = () => {
  const [i, setI] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setI((v) => (v + 1) % ORDERS.length), 3200);
    return () => clearInterval(t);
  }, []);

  const order = ORDERS[i];

  return (
    <div data-testid="order-ticker" className="bg-forest">
      <div className="mx-auto flex max-w-[1400px] items-center gap-4 px-6 py-4 md:px-12">
        <span className="inline-flex shrink-0 items-center gap-2 rounded-full bg-fresh/15 px-3 py-1.5">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-fresh opacity-60" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-fresh" />
          </span>
          <span className="font-manrope text-[10px] font-bold uppercase tracking-[0.25em] text-fresh">
            Live
          </span>
        </span>
        <div className="relative h-6 flex-1 overflow-hidden">
          <AnimatePresence mode="wait">
            <motion.p
              key={i}
              data-testid="order-ticker-item"
              {...ITEM_MOTION}
              className="absolute inset-0 truncate font-manrope text-sm font-semibold text-bone/90"
            >
              <span className="text-fresh">{order.hood}</span> — {order.detail}
            </motion.p>
          </AnimatePresence>
        </div>
        <span className="hidden shrink-0 items-center gap-2 font-manrope text-xs font-bold uppercase tracking-[0.2em] text-bone/50 sm:inline-flex">
          <Zap className="h-3.5 w-3.5 text-fresh" />
          Orders moving across Calgary right now
        </span>
      </div>
    </div>
  );
};
